
const headerElm = $("#sticky-header");

export function checkMobile(){

    let mobile_breakpoint = 768;
    let result = {
        "device_type": ""
    }

      let window_width = $(window).outerWidth();

      if (window_width < mobile_breakpoint) {
        result.device_type = "mobile"
      } else {
        result.device_type = "desktop";
      }
    // console.log("checkMobile: ",result);

    return result;

}

export function setMobileClass(){
    
    // $(window).on("load", function () {
    //   let device = checkMobile().device_type;
    //   if (device === "mobile") {
    //     headerElm.addClass("isMobile");
    //   } else if (device === "desktop") {
    //     headerElm.removeClass("isMobile");
    //   }
    // });
    
    $(window).on("load resize", function () {
    //   let device = checkMobile().device_type;
    let window_width = $(window).width();
      if (window_width < 768) {
        headerElm.addClass("isMobile");
      } else {
        headerElm.removeClass("isMobile");
      }
    });
}

export function mobileNavToggle(){
    
    const hbgMenu = $(".hbgMenu");
    const set_class = {
        "open": "isOpen",
        "close": "isClose"
    }

    $(hbgMenu).on('click',function(){
        $(this).toggleClass(set_class.open);
        headerElm.toggleClass(set_class.open);
    })
}